export const DEVICE_ID_LOCAL_STORAGE = 'cvt_id';
